import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonYporroiKentimata';
const args = {};

export class OligonYporroiKentimata extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
